import { useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from "react-pdf";
import { useWindowHeight } from '@wojtekmaj/react-hooks';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

function PDFViewer2({ url }) {

    const height = useWindowHeight();


    const viewPdfButton = useRef(null);

    useEffect(() => {
        if (url) {
            window.$(viewPdfButton.current).flipBook({
                //Layout Setting
                pdfUrl: url,
                btnToc: { enabled: true, title: "Tabla de contenidos", color: 'white' },
                btnPrev: { enabled: true, title: "Página anterior" },
                btnNext: { enabled: true, title: "Página siguiente" },
                btnSearch: { enabled: true, title: "Buscar", color: 'white' },
                btnBookmark: { enabled: true, title: "Marcadores", color: 'white' },
                btnThumbs: { enabled: true, title: "Miniaturas", color: 'white' },
                btnZoomIn: { enabled: true, title: "Acercar", color: 'white' },
                btnZoomOut: { enabled: true, title: "Alejar", color: 'white' },
                btnSelect: { enabled: true, title: "Seleccionar texto", color: 'white' },
                btnExpand: { enabled: true, title: "Pantalla completa", color: 'white' },
                btnClose: { enabled: false, title: "Cerrar", color: 'white' },
                lightBox: true,
                sound: true,
                btnBackgroundHover: "#25292c",
                layout: 2,
                currentPage: { vAlign: "bottom", hAlign: "left" },
                // BTN SETTING
                btnShare: { enabled: false },
                btnDownloadPdf: { enabled: false },
                btnPrint: {
                    enabled: false
                },
                btnDownloadPages: {
                    enabled: false
                },
                btnColor: 'rgb(255,120,60)',
                sideBtnColor: 'rgb(255,120,60)',
                sideBtnSize: 60,
                sideBtnBackground: "rgba(0,0,0,.7)",
                skin: 'dark',
                sideBtnRadius: 60,
                btnSound: { vAlign: "top", hAlign: "left" },
                btnAutoplay: { enabled: false },
                // SHARING
                strings: {
                    print: "Print",
                    printLeftPage: "Print left page",
                    printRightPage: "Print right page",
                    printCurrentPage: "Print current page",
                    printAllPages: "Print all pages",
                    download: "Download",
                    downloadLeftPage: "Download left page",
                    downloadRightPage: "Download right page",
                    downloadCurrentPage: "Download current page",
                    downloadAllPages: "Download all pages",
                    bookmarks: "Marcadores",
                    bookmarkLeftPage: "Marcar página izquierda",
                    bookmarkRightPage: "Marcar página derecha",
                    bookmarkCurrentPage: "Marcar página actual",
                    search: "Buscar",
                    findInDocument: "Buscar en el documento",
                    pagesFoundContaining: "páginas que continenen",
                    thumbnails: "Miniaturas",
                    tableOfContent: "Tabla de contenidos",
                    share: "Compartir",
                    pressEscToClose: "Press ESC to close",
                }

            })
        }
    }, [url])



    return (
        url &&
        <>
            <div className="PDFViewerContainer">
                <Document file={url}>
                    <Page height={height} pageNumber={1} />
                </Document>
                <a href="#" id="viewMagazine" ref={viewPdfButton} class="PDFViewerContainer-view-overlay">
                    <span>Leer</span>
                </a>
            </div>
        </>
    );
}

export default PDFViewer2;
